import styled from "styled-components";
import { ChevronDownCircle } from "react-iconly";

import { StyledAccordionItem } from "../../../../style/base/styledPublicPages";
import { Accordion } from "react-bootstrap";
import ButtonComponent from "../../button";

export const StyledAccordion = styled(Accordion)`
  border: 3px solid var(--primary-color);
  border-radius: 15px;
`;

export const StyledExerciseAccordionItem = styled(StyledAccordionItem)`
  border-width: 3px;
  button.accordion-button {
    display: grid;
    grid-template-areas: ". title icon";
    grid-template-columns: auto 250px auto;
    background-color: transparent;
    box-shadow: none;
    justify-content: space-between;

    &:not(.collapsed) {
      color: inherit;
    }
    .accordion-title {
      padding: 0.5rem 4.5rem;
      background: var(--button-color-labs);
      border-radius: 8px;
      grid-area: title;
    }

    &::after {
      content: none;
    }
    @media screen and (max-width: 575px) {
      grid-template-columns: 1fr 120px 1fr;
      .accordion-title {
        padding: 0.5rem;
      }
    }
  }
`;

export const StyledChevronUpCircle = styled(ChevronDownCircle)`
  &.accordion-icon {
    grid-area: icon;
    transition: all ease 0.3s;
    transform: ${({ $active }) => $active && "rotate(180deg)"};
    justify-self: left;
  }
`;

export const StyledTable = styled.table`
  width: 100%;
  margin-top: 30px;
  position: relative;
  transition: all ease 0.5s;
  border-collapse: separate;
  border-spacing: 0;
  background-color: var(--bg-color);
  tr {
    &:after {
      position: relative;
      top: 10px;
      left: 0px;
      ${({ $checked }) =>
        $checked === "check-is-true"
          ? `content:"✔️" `
          : $checked === "check-is-false"
          ? `content:"❗" `
          : ""};
    }

    &.check-is-true:after {
      content: "✔️";
    }
    &.check-is-false:after {
      content: "❗";
    }
  }

  th,
  td {
    text-align: center;
    border-right: 2px solid var(--primary-color);
    border-bottom: 2px solid var(--primary-color);
    &:first-child {
      border-left: 2px solid var(--primary-color);
    }
  }
  thead th {
    border-top: 2px solid var(--primary-color);
    &:first-child {
      border-top-left-radius: 12px;
    }
    &:last-child {
      border-top-right-radius: 12px;
    }
  }
  tbody {
    tr:last-child td:first-child {
      border-bottom-left-radius: 12px;
    }
    tr:last-child td:last-child {
      border-bottom-right-radius: 12px;
    }

    .input-exercise {
      padding: 3px;
      margin: 5px 0;
      border-radius: 3px;
      border: 1px dashed var(--blue-color-dark);
      width: fit-content;
      &[type="number"]::-webkit-outer-spin-button,
      &[type="number"]::-webkit-inner-spin-button {
        appearance: none;
        margin: 0;
        display: none;
      }
    }
  }
`;

export const TableRow = styled.tr`
  &:after {
    position: relative;
    top: 10px;
    left: 0px;
    ${({ $checked }) =>
      $checked === "check-is-true"
        ? `content:"✔️" `
        : $checked === "check-is-false"
        ? `content:"❗" `
        : ""};
  }

  &.check-is-true:after {
    content: "✔️";
  }
  &.check-is-false:after {
    content: "❗";
  }
`;

export const ExerciseResultImg = styled.img`
  width: 120px;
`;

export const ExerciseSubmitBtn = styled(ButtonComponent)`
  border-width: 2px;
  font-weight: 500;
  width: 170px;
  &.btn-outline-primary {
    color: var(--primary-color);
  }
`;
